import React from 'react'
import PropTypes from 'prop-types'
import { SetInitialConstraints, RouteParameterFilter, StaticFilter } from '@morningtrain/react-filters'
import Form from './Form'

import { Resources } from '@morningtrain/resources'
import useOperation from './hooks/use-operation'
import useModel from './hooks/use-model'
import { getMapValue } from '@morningtrain/react-helpers'
import ModelPayload from './ModelPayload'
import { ConstrainableOperation } from './constraining'

function Model (props) {
  const parentOperation = useOperation()
  const parentModel = useModel()

  const [id, setId] = React.useState(props.id)

  React.useEffect(() => {
    if (props.id !== id) {
      setId(props.id)
    }
  })

  function resourceName () {
    if (props.proxy === true && !props.resourceName && parentOperation) {
      return parentOperation.resource.slug
    }

    return props.resourceName
  }

  function operation () {
    return Resources.make(props.namespace, resourceName())
      .operation(props.operationName)
  }

  function initialContraints () {
    if (props.autoFetch === false) {
      return {}
    }

    const constraints = {}

    if (props.proxy === true && parentModel) {
      constraints[parentOperation.parameterKey] = getMapValue(parentModel, parentOperation.modelKey)
    } else if (id) {
      constraints[operation().parameterKey] = id
    }

    return constraints
  }

  function operationContext () {
    if (props.clean === true) {
      return props.operationContext
    }

    const context = { ...initialContraints() }

    return context
  }

  function renderChildren () {
    return (
      <>
        {props.children}
      </>
    )
  }

  function renderInner () {
    if (!props.submittable) {
      return renderChildren()
    }

    return (
      <Form submitTo={props.submitoperationName} beforePipes={props.beforePipes}>
        {renderChildren()}
      </Form>
    )
  }

  function renderFilters () {
    if (props.proxy === true || props.autoFetch === false) return null

    return id
      ? <StaticFilter value={id} name={operation().parameterKey} />
      : <RouteParameterFilter name={operation().parameterKey} />
  }

  const operationProps = {
    namespace: props.namespace,
    resourceName: resourceName(),
    operationName: props.operationName,
    proxy: props.proxy,
    operationContext: operationContext(),
    persist: props.persist,
    provideErrors: props.provideErrors,
    useParentConstrainable: props.useParentConstrainable
  }

  return (
    <ConstrainableOperation {...operationProps}>
      <SetInitialConstraints constraints={initialContraints()} />
      <ModelPayload proxy={props.proxy} proxyFrom={props.proxyFrom}>
        {renderInner()}
        {renderFilters()}
      </ModelPayload>
    </ConstrainableOperation>
  )
}

Model.defaultProps = {
  namespace: 'api',
  operationName: 'read',
  operationContext: {},
  submitoperationName: 'store',
  submittable: false,
  proxy: false,
  proxyFrom: null,
  persist: false,
  clean: false,
  autoFetch: true,
  provideErrors: true,
  beforePipes: null,
  useParentConstrainable: false
}

Model.propTypes = {
  namespace: PropTypes.string,
  operationName: PropTypes.string,
  operationContext: PropTypes.any,
  submitoperationName: PropTypes.string,
  submittable: PropTypes.bool,
  proxy: PropTypes.bool,
  proxyFrom: PropTypes.any,
  persist: PropTypes.bool,
  clean: PropTypes.bool,
  autoFetch: PropTypes.bool,
  provideErrors: PropTypes.bool,
  beforePipes: PropTypes.node,
  useParentConstrainable: PropTypes.bool
}

export default Model
